import React from 'react'
import { Modal } from 'react-bootstrap'
import agenda from '../../images/event/EMC-agenda.jpg'
import { COLORS } from '../../styles/theme'
import styled from 'styled-components'

const StyledModal = styled(Modal)`
  .modal-content {
    background-color: rgba(255, 255, 255, 0.85);
    border-radius: 0px;
    padding: 36px;
  }
  .modal-header {
    border: none;
    padding: 0 16px;
  }
  .modal-body {
    padding: 0 16px;
  }
  .btn {
    display: block;
    width: 100%;
    margin-left: auto;
    border: none;
    border-radius: 28px;
    padding: 6px 16px;
    background: ${COLORS.primaryLight};
  }
  #refresh {
    display: block;
    margin: 0 auto;
    padding: 12px 36px;
    border: 2px solid white;
    border-radius: 28px;
    color: white;
    background: ${COLORS.primaryLight};
  }
`

export default function SpeakersModal({ showModal, hideModal }) {
  return (
    <StyledModal show={showModal} onHide={hideModal} size="lg" aria-labelledby="speakers-bio" centered>
      <Modal.Body>
        <h5 className="py-3 px-2 px-md-5 text-center">Coming Soon!</h5>
      </Modal.Body>
    </StyledModal>
  )
}
